import './index.styl'
import { buildImage } from '@/utils/action-lib'

const Index = {
  template() {
    const {
      switcher,
      reg_backgrounds,
      landing_backgrounds,
    } = window.__INIT_STATE__

    const bgs = (
      switcher.skipLanding === true
        ? reg_backgrounds
        : landing_backgrounds
    ).filter((item) => +item.action === 1)
    return `${bgs.map((item) => buildImage(item)).join('')}`
  },
}
export default Index
